<template>
  <v-sheet elevation="1">
    <span class="body pa-3 d-block">{{orderBy}}</span>
    <v-row
      dense
      align="center"
      class="pa-3"
    >
      <v-col cols="12" sm="8">
        <v-row dense>
          <v-col cols="auto">
            <v-menu
              ref="menuFromDate"
              v-model="menuFromDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  hide-details
                  outlined
                  class="caption"
                  :placeholder="$_strings.common.FROM_DATE"
                  :value="dayjs(filters.shipmentDateStart).format('DD-MM-YYYY')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.shipmentDateStart"
                no-title
                :max="filters.shipmentDateEnd"
                @change="menuFromDate = false"
                locale="id"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="d-sm-flex d-none align-center" cols="auto">-</v-col>
          <v-col cols="auto">
            <v-menu
              ref="menuToDate"
              v-model="menuToDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  hide-details
                  class="caption"
                  outlined
                  :value="dayjs(filters.shipmentDateEnd).format('DD-MM-YYYY')"
                  :placeholder="$_strings.common.TO_DATE"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :min="filters.shipmentDateStart"
                v-model="filters.shipmentDateEnd"
                no-title
                @change="menuToDate = false"
                locale="id"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <FilterBy
              v-bind="$props"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="3"
        class="ml-md-auto"
      >
        <v-text-field
          v-model="search"
          dense
          hide-details
          outlined
          class="caption"
          @keyup.native.enter="setSearch"
          :placeholder="searchPlaceholder"
        >
          <template v-slot:prepend-inner>
            <v-icon @click="setSearch">
              mdi-magnify
            </v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import dayjs from 'dayjs';
import FilterBy from './FilterBy.vue';

export default {
  name: 'filter-order',
  props: {
    orderBy: String,
    filters: {
      type: Object,
      default: () => {},
    },
    itemsFilter: {
      type: Object,
      default: () => {},
    },
    pageFilters: {
      type: Object,
      default: () => {},
    },
    searching: {
      type: Number,
      default: 0,
    },
  },
  components: {
    FilterBy,
  },
  mounted() {
    const { shipmentDateStart, shipmentDateEnd } = this.$route.query;
    const currentDate = dayjs().add('7', 'days').format('YYYY-MM-DD');
    this.filters.shipmentDateStart = shipmentDateStart || dayjs(currentDate).subtract(7, 'day').format('YYYY-MM-DD');
    this.filters.shipmentDateEnd = shipmentDateEnd || currentDate;
  },
  computed: {
    searchPlaceholder() {
      const { status } = this.$route.params;
      const pageConfirmation = ['confirmation_transporter', 'confirmation_driver'];
      if (pageConfirmation.includes(status)) return 'Cari No. Kargo';
      return 'Cari No. Kiriman/Pesanan/Cargo';
    },
  },
  data() {
    return {
      filterBy: [
        {
          text: 'Cancel',
          value: 'cancel',
        },
        {
          text: 'Confirm',
          value: 'confirm',
        },
      ],
      search: this.$route.query.search || '',
      menuFromDate: false,
      menuToDate: false,
    };
  },
  watch: {
    'filters.shipmentDateStart': function shipmentDateStart(newVal, oldVal) {
      if (this.$route.query.shipmentDateStart !== newVal) {
        this.$router.replace({
          name: this.$route.name,
          query: {
            ...this.$route.query,
            shipmentDateStart: newVal,
            page: 1,
          },
        });
      }
      if (oldVal) {
        this.$emit('fetching');
      }
    },
    'filters.shipmentDateEnd': function setShipmentDateEnd(newVal, oldVal) {
      if (this.$route.query.shipmentDateEnd !== newVal) {
        this.$router.replace({
          name: this.$route.name,
          query: {
            ...this.$route.query,
            shipmentDateEnd: newVal,
            page: 1,
          },
        });
      }
      if (oldVal) {
        this.$emit('fetching');
      }
    },
  },
  methods: {
    dayjs,
    setSearch() {
      this.filters.shipmentNumber = this.search;
      if (this.search !== this.$route.query.search) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            search: this.search,
            page: 1,
          },
        });
      }
      this.$emit('fetching');
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field--outlined.v-input--dense .v-input__control .v-text-field__slot > label.v-label {
  font-size: 10px !important;
  color: red !important;
}
</style>
